<script setup lang="ts">
import { useTutorApplicationStore } from '../model/store'
import FormBox from './FormBox.vue'
import InputNationality from './additional-questions/InputNationality.vue'
import AgeConfirmation from './additional-questions/AgeConfirmation.vue'
import InputReferrerFullName from './additional-questions/InputReferrerFullName.vue'
import InputJobPostingSite from './additional-questions/InputJobPostingSite.vue'
import BachelorDegree from './additional-questions/BachelorDegree.vue'
import TeachingExperienceYears from './additional-questions/TeachingExperienceYears.vue'
import WorkRequiredSchedule from './additional-questions/WorkRequiredSchedule.vue'
import OnboardingTimeframe from './additional-questions/OnboardingTimeframe.vue'
import TeacherRecommended from './additional-questions/TeacherRecommended.vue'
import ReferralSource from './additional-questions/ReferralSource.vue'

defineOptions({
  name: 'AdditionalQuestions',
})

const tutorApplicationStore = useTutorApplicationStore()

const setClear = (): void => {
  tutorApplicationStore.resetAdditionalQuestions()
}

</script>

<template>
  <FormBox
    title="Additional questions"
    @click:clear="setClear"
  >
    <div class="additional-questions__fields">
      <InputNationality />
      <AgeConfirmation />
      <TeacherRecommended />
      <InputReferrerFullName />
      <ReferralSource />
      <InputJobPostingSite />
      <BachelorDegree />
      <TeachingExperienceYears />
      <WorkRequiredSchedule />
      <OnboardingTimeframe />
    </div>
  </FormBox>
</template>

<style scoped lang="scss" src="./AdditionalQuestions.scss" />
